const exercice = {
  title: "Commencez votre liasse fiscale LMNP",
  form: {
    email: {
      label: "Votre adresse email",
      placeholder: "moblihome@gmail.com",
    },
    annee: {
      label: "Année à déclarer",
    },
    hasSiren: {
      label: "Avez-vous rempli votre P0i, et avez-vous déjà un SIREN ?",
    },
    siren: {
      label: "Saisissez votre SIREN sur 9 chiffres",
      placeholder: "SIREN sur 9 chiffres",
    },
  },
  buttonSubmit: "Continuer",
};

const adresse = {
  title: "Adresse et début d’activité de votre LMNP",
  form: {
    dateDebutActivite: {
      label: "Date de début d’activité",
    },
    adresse: {
      label: "Adresse de l’activité (du bien)",
      placeholder: "Adresse",
    },
    codePostal: {
      placeholder: "Code postal",
    },
    ville: {
      placeholder: "Ville",
    },
  },
  buttonReturn: "Retour à Exercice",
  buttonSubmit: "Suivant",
};

const votreBien = {
  title1: "Votre bien en LMNP",
  title2: "Vos biens en LMNP",
  linkAddNew: "Ajouter un bien",
  buttonReturn: "Retour à Adresse",
  buttonSubmit: "Suivant",
};

const votreBienForm = {
  title: "Votre bien en LMNP",
  form: {
    adresse: {
      label: "Adresse du bien",
      placeholder: "Adresse",
    },
    codePostal: {
      placeholder: "Code postal",
    },
    ville: {
      placeholder: "Ville",
    },
    dateAcquisition: {
      label: "Date d’acquisition du bien",
    },
    dateEntreeLMNP: {
      label: "Date de mise en location LMNP du bien",
    },
    prixDAchatOuEvaluation: {
      option1: {
        label: "Prix d’acquisition du bien",
        infoText:
          "Indiquez comme prix d'acquisition le prix d'achat de votre bien, sans les frais de notaire ni frais d'agence, que vous pourrez détailler dans les cases suivantes.",
      },
      option2: {
        label: "Valeur estimée du bien",
        infoText:
          "Si le bien a été acquis depuis plus de deux ans, vous ne pouvez plus intégrer les frais de notaire et d'agence. Vous devez estimer ou faire estimer la valeur de votre bien à la date de première mise en location, c'est cette valeur qui sera prise en compte pour les amortissements LMNP.",
      },
    },
    travauxInitiaux: {
      label:
        "Coût des travaux réalisés la 1ère année consécutivement à l'achat",
    },
    coutsMeubles: {
      label: "Coût total des meubles et équipements du bien loué",
    },
    fraisNotaires: {
      label: "Frais de notaire",
    },
    fraisAgence: {
      label: "Frais d'agence",
    },
    commentaire: {
      label: "Commentaires et remarques",
      placeholder: "commentaires",
    },
  },
  buttonReturn: "Retour à Votre bien",
  buttonSubmit: "Suivant",
};

const votreBienForm2 = {
  title: "Vos revenus et dépenses LMNP en ",
  titleSmall: "Bien au {adresse}, {codePostal} {ville}",
  form: {
    totalEncaisse: {
      label: "Montant total des loyers encaissés y compris charges refacturées",
    },
    totalDepensesCourantes: {
      label1: "Montant total de vos dépenses annuelles courantes",
      label2: `Ensemble des charges d'électricité, d'eau, de gaz,
      d'entretien, de co-propriété, frais d'agence, assurance
      "propriétaire bailleur", assurance "loyers impayés",
      assurance "partie commune", factures diverses, etc. Hors
      Travaux et dépenses d'équipements supérieurs à 500€ TTC,
      Impôts, Charges financières et Assurance Prêt Immobilier à
      détailler ci-après`,
    },
    totalTravaux: {
      label1:
        "Montant des dépenses de travaux réalisés en {annee}, supérieures à 500€",
      label2: "(le cas échéant - hors travaux réalisés la première année)",
    },
    depensesEquipement: {
      label:
        "Montant des dépenses d'équipements acquis en {annee}, au montant unitaire supérieur à 500€",
    },
    impotsTaxeFonciere: {
      label1: "Impôts - Taxe foncière",
      label2: "(le cas échéant)",
    },
    impotsCFE: {
      label1: "Impôts-CFE",
      label2: "(le cas échéant)",
    },
    chargesFinancieres: {
      label1: `Charges financières - Montant des intérêts du prêt bancaire
      payés de l'année`,
      label2: "+ Montant des primes d'assurance sur le prêt",
      label3: "(intérêts uniquements, sans le capital remboursé)",
    },
    empruntCapitalRestantDu: {
      label: "Montant du capital restant dû au 31/12/{annee}",
    },
    commentaire: {
      placeholder: "commentaires",
    },
    fieldset1: "Vos revenus locatifs {annee} pour le {adresse}",
    fieldset2: "Vos dépenses locatives {annee} pour le {adresse}",
    fieldset3: "Emprunt éventuel contracté pour l’acquisition du {adresse}",
    fieldset4: "Commentaires libres sur l’activité {annee} sur ce bien",
  },
  buttonReturn: "Annuler",
  buttonSubmit: "Valider et terminer",
};

const votreActivite = {
  title: "Récapitulatif de vos éléments {annee}",
  form: {
    commentaire: {
      placeholder: "commentaires",
    },
    fieldset1: "Vos revenus locatifs {annee} LMNP",
    fieldset2: "Vos dépenses locatives {annee} LMNP",
    fieldset3: "Emprunts éventuels",
    fieldset4: "Commentaires libres sur l’activité {annee} sur l’exercice",
  },
  buttonReturn: "Retour à la liste des biens",
  buttonSubmit: "Valider et envoyer à TELEDEC",
};

const votreLiasseFiscale = {
  title1: "Merci, nous revenons vers vous rapidement",
  title2: "avec votre projet de Liasse Fiscale LMNP {annee}",
};

export {
  exercice,
  adresse,
  votreBien,
  votreBienForm,
  votreBienForm2,
  votreActivite,
  votreLiasseFiscale,
};
